import AllRevenueForMDA from "./AllRevenueforMda";
import NewCustomer from "./NewCustomer";
import Overview from "./Overview";
import React from "react";
import Table from "./Table";
import TableForRevHead from "./TableForRevHead";
import styles from "./Earning.module.sass";

function MDAsDetails() {
  const mdaName = JSON.parse(localStorage.getItem("mdaName"));

  return (
    <div>
      {/* MDAsDetails */}
      <h1 style={{ marginBottom: "2rem" }}>{mdaName}</h1>

      <Overview />
      <AllRevenueForMDA />
      {/* <div style={{ height: '400px', overflow: 'scroll' }}></div> */}
      {/* <OverviewCard /> */}
      <Table />
      <NewCustomer />

      {/* <div className={styles.row}>
        <div className={styles.col}>
          <div
            style={{
              height: "350px",
              overflow: "scroll",
            }}
          ></div>
        </div>
        <div className={styles.col}></div>
      </div> */}

      <TableForRevHead />
    </div>
  );
}

export default MDAsDetails;
